import { EMPTY_ARRAY } from '@e-socna/empty';
import { normalizeLastName } from '@e-socna/third-parties';
import type { Id } from '@e-socna/data-layer';

import { generateId } from '../../../utils/generate-id.util';

import { capitalizeName } from '../utils/capitalize-name.util';
import type { ActiveMembership } from '../types/active-membership.type';
import type { OrganizationSearchDirectorPersonnePhysique } from '../types/organization-search-result.type';

const YEAR_MONTH_PATTERN = /^\d{4}-\d{2}$/;
const YEAR_PATTERN = /^\d{4}$/;

export const resolveDirectorBirthDate = (
  director: Readonly<OrganizationSearchDirectorPersonnePhysique>,
): string | undefined => {
  if (
    director.date_de_naissance &&
    YEAR_MONTH_PATTERN.test(director.date_de_naissance)
  ) {
    return `${director.date_de_naissance}-01`;
  }

  if (
    director.annee_de_naissance &&
    YEAR_PATTERN.test(director.annee_de_naissance)
  ) {
    return `${director.annee_de_naissance}-01-01`;
  }

  return undefined;
};

export const buildPersonInitialValuesFromDirector = (
  director: Readonly<OrganizationSearchDirectorPersonnePhysique>,
  { fallbackCivilityId }: Readonly<{ fallbackCivilityId: Id }>,
) => ({
  firstName: director.prenoms ? capitalizeName(director.prenoms) : undefined,
  lastName: director.nom ? normalizeLastName(director.nom) : undefined,
  birthDate: resolveDirectorBirthDate(director),
  civilityId: fallbackCivilityId,
});

export const buildActiveMembershipFromDirector = (
  director: Readonly<OrganizationSearchDirectorPersonnePhysique>,
  {
    personId,
    representativeTypeId,
  }: Readonly<{
    personId: Id;
    representativeTypeId: Id;
  }>,
): ActiveMembership => ({
  __typename: 'OrganizationMembership' as const,
  _id: generateId(),
  contextualRoleIds: EMPTY_ARRAY,
  functions: director.qualite ? [director.qualite] : EMPTY_ARRAY,
  personId,
  representativeTypeIds: [representativeTypeId],
});
